<div class="smartphone">
  <div class="chat">
    <div class="messages">
      <span class="amp-message-sms" *ngIf="text?.length > 0 && type == 'sms'">{{ text }}<br /><a class="amp-message-sms-link">https://ampl.me/ABC123</a></span>
      <span class="amp-message-sms" *ngIf="text?.length > 0 && type == 'whatsapp'">{{ text }}<br /><a class="amp-message-sms-link">https://ampl.me/ABC123</a><span><br>Caso o link não esteja clicável, responda SIM para ativar.</span></span>
    </div>
  </div>
</div>
